import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent } from '../../schema'

type Stage = OpalApiComponent<'V2', 'stage'>

type Attributes = {
  stageType: 'approval' | 'task' | 'circuit_breaker'
  position?: number
  stageId?: string
  workflowId?: string
}

const defaultAttributes: Omit<
  OpalApiComponent<'V2', 'stage'>['attributes'],
  'stage_type' | 'position'
> = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  deleted_at: null,
  activated_at: null,
  status: 'inactive',
  due_date: null,
  metadata: null,
}

export const resourceObject = ({
  stageType,
  stageId,
  position = 0,
  workflowId,
}: Attributes): Stage => ({
  id: stageId ?? uuidv4(),
  type: 'stage',
  attributes: {
    ...defaultAttributes,
    stage_type: stageType,
    position,
  },
  relationships: {
    assignments: {
      data: [],
    },
    workflow: {
      data: { id: workflowId ?? uuidv4(), type: 'workflow' },
    },
  },
})
